import { CloudRain } from "lucide-react";
import { BAD_WEATHER, weatherRecap } from "../lib/trends";

export const WeatherRecap = ({ jobs, logs }) => {
  const rows = weatherRecap(jobs, logs);
  return (
    <div data-testid="weather-recap-card" className="panel overflow-x-auto">
      <div className="label flex items-center gap-2 px-5 pt-5"><CloudRain className="h-4 w-4 text-sky-400" /> Work days lost to bad weather</div>
      <table data-testid="weather-recap-table" className="mt-3 w-full min-w-[720px] text-sm">
        <thead>
          <tr className="border-b border-[color:var(--border)] text-left">
            {["Job", "Days Logged", "Days Lost", "% Lost", ...BAD_WEATHER].map((h) => <th key={h} className="label px-4 py-3 font-normal">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.job.id} data-testid={`weather-row-${r.job.id}`} className="border-b border-[color:var(--border)] last:border-0">
              <td className="px-4 py-3 font-display font-semibold">{r.job.no}. {r.job.name}</td>
              <td className="px-4 py-3 font-mono">{r.daysLogged}</td>
              <td data-testid={`weather-days-lost-${r.job.id}`} className="px-4 py-3 font-mono text-lg font-bold text-red-400">{r.daysLost}</td>
              <td className="px-4 py-3 font-mono text-amber-400">{r.pct.toFixed(0)}%</td>
              {BAD_WEATHER.map((w) => <td key={w} className="px-4 py-3 font-mono text-[color:var(--muted)]">{r.breakdown[w]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
      <p className="border-t border-[color:var(--border)] px-4 py-3 font-mono text-[11px] text-[color:var(--muted)]">
        A day counts as lost when a daily log for the job records {BAD_WEATHER.join(", ")}. Each date counts once per job.
      </p>
    </div>
  );
};
